// @flow
import React from "react";
import Dropdown, { type DropdownOptions } from "../../Dropdown";

import dropdownStyles from "./dropdownStyles.scss";
import styles from "./AdditionalTitles.scss";

import ThreeDotsIcon from "../../../assets/icons/other/threeDots.svg";

type AdditionalTitlesProps = {
  dropdownOptions: DropdownOptions,
  dropdownActiveIndex: number
};

const AdditionalTitles = ({ dropdownOptions, dropdownActiveIndex }: AdditionalTitlesProps) => {
  if (!dropdownOptions.length) {
    return null;
  }

  return (
    <div className={styles.dropdownContainer}>
      <Dropdown
        icon={ThreeDotsIcon}
        options={dropdownOptions}
        activeIndex={dropdownActiveIndex}
        popperWidth={150}
        additionalStyles={dropdownStyles}
        onLeft
      />
    </div>
  );
};

export default AdditionalTitles;
